import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSyncroMspPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetSyncroPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getSyncroMspPodDataByContactId',
  async ({ psaId, contactId }) =>
    getSyncroMspPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
